import { render, staticRenderFns } from "./FunnelChart.vue?vue&type=template&id=72121164&scoped=true&"
import script from "./FunnelChart.vue?vue&type=script&lang=js&"
export * from "./FunnelChart.vue?vue&type=script&lang=js&"
import style0 from "./FunnelChart.vue?vue&type=style&index=0&id=72121164&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72121164",
  null
  
)

export default component.exports